/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_Analysis_FailedInputs */

const en_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const de_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const fr_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const es_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const it_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const nl_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const pl_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const fi_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const da_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

const sv_keyword_optimizer_toast_analysis_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis failed`)
};

/**
* | output |
* | --- |
* | "Analysis failed" |
*
* @param {Keyword_Optimizer_Toast_Analysis_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_analysis_failed = /** @type {((inputs?: Keyword_Optimizer_Toast_Analysis_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Analysis_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_analysis_failed(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_analysis_failed(inputs)
	return en_keyword_optimizer_toast_analysis_failed(inputs)
});